import { useGetApiAccount } from '../gen';

export function useAccount() {
  return useGetApiAccount({
    query: {
      staleTime: Infinity,
      throwOnError: true,
      refetchOnMount: false,
      notifyOnChangeProps: ['data'],
    },
  });
}

export function useHomeRouteAccount() {
  return useGetApiAccount({
    query: {
      staleTime: Infinity,
      throwOnError: false,
      retry: false,
      refetchOnMount: false,
      notifyOnChangeProps: ['data', 'error'],
    },
  });
}
